export const Permissions = {
  Staff: {
    VIEW: 'viewStaff',
    ADD: 'addStaff',
    EDIT: 'editStaff',
    DELETE: 'deleteStaff',
    ADD_OWN: 'addStaff_own',
    VIEW_OWN: 'viewStaff_own',
    EDIT_OWN: 'editStaff_own',
    DELETE_OWN: 'deleteStaff_own',
    EDIT_INTEGERATION_OWN: 'editStaff_integeration_own',
    EDIT_IMAGE_OWN: 'editStaff_image_own',
  },
  Business: {
    VIEW: 'viewBusiness',
    ADD: 'addBusiness',
    EDIT: 'editBusiness',
    DELETE: 'deleteBusiness',
  },
  BookingType: {
    VIEW: 'viewBookingType',
    ADD: 'addBookingType',
    EDIT: 'editBookingType',
    DELETE: 'deleteBookingType',
    VIEW_OWN: 'viewBookingType_own',
    EDIT_OWN: 'editBookingType_own',
    DELETE_OWN: 'deleteBookingType_own'
  },
  Calendar: {
    VIEW: 'viewCalendar',
    ADD: 'addCalendar',
    EDIT: 'editCalendar',
    DELETE: 'deleteCalendar',
    VIEW_OWN: 'viewCalendar_own',
    EDIT_OWN: 'editCalendar_own',
    DELETE_OWN: 'deleteCalendar_own'
  },
  Resident: {
    VIEW: "viewResident",
    ADD: "addResident",
    EDIT: "editResident",
    DELETE: "deleteResident",
  },
  Job: {
    VIEW: "viewJob",
    ADD: "addJob",
    EDIT: "editJob",
    DELETE: "deleteJob",
  }
};

export const hasPermission = (
  userPermissions,
  requiredPermission,
  resourceOwnerId,
  loggedInUserId
) => {
  // Check if requiredPermission ends with "_own"
  const isOwnPermission = requiredPermission.endsWith("_own");

  // If the user has the exact required permission:
  if (userPermissions.includes(requiredPermission)) {
    // If it's an "own" permission, confirm ownership.
    if (isOwnPermission) {
      return resourceOwnerId && Number(resourceOwnerId) === Number(loggedInUserId);
    }
    // Otherwise, grant access.
    return true;
  }

  // If the required permission is not an "own" permission, 
  // check if the user has the "own" variant of that permission.
  if (!isOwnPermission) {
    const ownPermission = `${requiredPermission}_own`;
    if (userPermissions.includes(ownPermission)) {
      // Only grant if the resource is owned by the logged in user.
      return resourceOwnerId && Number(resourceOwnerId) === Number(loggedInUserId);
    }
  }

  // If none of the conditions are met, deny access.
  return false;
};

